import { api } from "..";
import { store } from "../../store/store";

interface QueryType {
    query: string;
    model_id: string;
    element_id?: number;
    label?: boolean;
}
function getModelPath(modelID: number | string) {
    if (!!Number(modelID) || Number(modelID) === 0) {
        return (
            store
                .getState()
                .viewerMain.models[Number(modelID)]?.model_id.split(".min")[0] +
            "_props.json"
        );
    } else {
        return (modelID as string).split(".min")[0] + "_props.json";
    }
}

export const paramsApi = api.injectEndpoints({
    endpoints: (builder) => ({
        checkRelevance: builder.mutation<boolean, QueryType>({
            query: (params: QueryType) => {
                const model_id = getModelPath(params.model_id);
                if (!model_id) return "/error";
                return {
                    url: `/bimatterAssistant/checkRelevance`,
                    method: "POST",
                    body: { ...params, model_id },
                };
            },
        }),
        getRelevantElements: builder.mutation<number[], QueryType>({
            query: (params: QueryType) => {
                const model_id = getModelPath(params.model_id);
                if (!model_id) return "/error";
                return {
                    url: `/bimatterAssistant/getRelevantElements`,
                    method: "POST",
                    body: { ...params, model_id },
                };
            },
        }),
        learn: builder.mutation<void, QueryType>({
            query: (params: QueryType) => {
                const model_id = getModelPath(params.model_id);
                if (!model_id) return "/error";
                return {
                    url: `/bimatterAssistant/learn`,
                    method: "POST",
                    body: { ...params, model_id },
                };
            },
        }),
    }),
});

export const {
    useCheckRelevanceMutation,
    useGetRelevantElementsMutation,
    useLearnMutation,
} = paramsApi;
